import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App.tsx"
import "./index.css"
import { Toaster } from "react-hot-toast"
import * as Sentry from "@sentry/react"
import { ClerkProvider } from "@clerk/clerk-react"
import { captureInvitation } from "./utils/account-session"

// Strip invitation secrets before initializing telemetry or Clerk.
if (window.location.pathname === "/learner-invitation") captureInvitation()

Sentry.init({
  dsn: "https://5ce5b5a0cfd3545bc2979b9192ef59a6@o4509712797925376.ingest.us.sentry.io/4509712873488384",
  sendDefaultPii: true,
})

import { BrowserRouter } from "react-router-dom"
import { ChakraProvider } from "@chakra-ui/react"

const clerkPubKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

if (!clerkPubKey) {
  throw new Error("Missing Clerk Publishable Key")
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ClerkProvider publishableKey={clerkPubKey}>
      <BrowserRouter>
        <ChakraProvider>
          <Toaster />
          <App />
        </ChakraProvider>
      </BrowserRouter>
    </ClerkProvider>
  </React.StrictMode>,
)
